<div class="container-fluid content-box home-frame">
    <div class="h-100 row align-items-center ">
        <div class="col welcome-main">
            Welcome to OHI System Administrator            
        </div>
    </div>
</div>